// extracted by mini-css-extract-plugin
export default {"loadController":"style_loadController__IfZkt","loadController_spiner":"style_loadController_spiner__KOz-G"};